import { LookupAPNAddressResponse } from 'src/types/address';
import { getAPIManagerInstance } from './apiManager';
import { DECKARD_API_URL, httpMethodFunctions } from './common';

const SMARTY_STREETS_API_KEY = process.env.REACT_APP_SMARTY_API_KEY;
const SMARTY_STREETS_LICENSE = process.env.REACT_APP_SMARTY_LICENSE;

export const lookupAddress = async (
  searchTerm: string,
  selected = undefined
) => {
  const SMARTY_STREETS_BASE_URL = `https://us-autocomplete-pro.api.smartystreets.com/lookup`;
  const params = {
    key: SMARTY_STREETS_API_KEY,
    license: SMARTY_STREETS_LICENSE,
    selected: selected || '',
    search: searchTerm,
    source: 'all',
  };
  return await httpMethodFunctions.get(SMARTY_STREETS_BASE_URL, {
    params,
  });
};

export const lookupAPNAddress = async (
  apn: string,
  unitNumber = ''
): Promise<LookupAPNAddressResponse | undefined> => {
  if (!apn) return;
  try {
    let url = `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/apn/${apn}`;

    // Add unitNumber to query string if valid
    if (!!unitNumber) {
      url += `?unitNumber=${encodeURIComponent(unitNumber)}`;
    }
    let resp = await httpMethodFunctions.get(url);
    let { data } = resp;
    return data as LookupAPNAddressResponse;
  } catch (err: unknown) {
    console.error('Error loading APN address:', err);
    return undefined;
  }
};

export const lookupAddressAPN = (address: string) => {
  if (!address) return;
  try {
    let result = httpMethodFunctions.get(
      `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/lookupAddress/${encodeURIComponent(address)}`
    );
    return result;
  } catch (err) {
    // Log err
  }
};
